import { rgbToCMYK } from "client/services/Color/utils/rgbToCMYK";
import { useColorComponent } from "../useColorComponent";
import tinycolor from "tinycolor2";
import { ColorComponentContainer } from "../ColorComponentContainer";

export interface CMYKProps {
    hex: string;
}

export const CMYK = ({ hex }: CMYKProps) => {
    const { r, g, b, a } = tinycolor(hex).toRgb();
    const cmyk = rgbToCMYK(r, g, b, a * 100);
    const { color, components, handleChange } = useColorComponent(cmyk, "cmyk");
    return (
        <>
            {(Object.keys(components) as Array<keyof typeof components>).map((key) => {
                const component = components[key];
                return (
                    <ColorComponentContainer
                        componentKey={key}
                        type={component.type}
                        value={color[key]}
                        max={component.max}
                        handleChange={handleChange}
                    />
                );
            })}
        </>
    );
};
